import { WEB_SERVICES } from "../../../../bitSagas/webServices";
import { USER_TYPE } from '../../../../bitConstants/constants';
import { WEBSERVICE_ERRORS } from '../../../errorCatalog';

export const getHandledErrors = (errorToPrint) => {
  const handledErrors = {
    common: {
      BUSINESS_ERRORS: {
        INCOMPATIBLE_CLIENT_PRODUCTS: errorToPrint.BLOCKED_BY_NETFLIX,
      },
      WEB_SERVICES_RULES: {
        [WEB_SERVICES.INIT_CQ]: {
          [WEBSERVICE_ERRORS.INCOMPATIBLE_PRODUCT_BY_ZONE]: errorToPrint.INCOMPATIBLE_PRODUCT_BY_ZONE,
        },
        [WEB_SERVICES.UPDATE_CQ]: {
          [WEBSERVICE_ERRORS.CLIENT_WITH_RISK]: errorToPrint.CLIENT_WITH_RISK,
        },
        [WEB_SERVICES.GET_LEGAL_TERMS]: {
          [WEBSERVICE_ERRORS.CLIENT_WITH_RISK]: errorToPrint.CLIENT_WITH_RISK,
        },
        [WEB_SERVICES.UPDATE_CA]: {
          [WEBSERVICE_ERRORS.ACCOUNT_WITH_RISK]: errorToPrint.ACCOUNT_WITH_RISK,
        },
      },
    },
    [`user_${USER_TYPE.TELCO}`]: {
      WEB_SERVICES_RULES: {
        [WEB_SERVICES.INIT_CQ]: {
        },
      },
    },
    [`user_${USER_TYPE.OPEN}`]: {

    },
  }

  return handledErrors;
}
